import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import InstaIframe from "../../../InstaIframe";

function InstaLondon() {
  return (
    <>
      <section className="Lt_LearnDiamond_section pb-0">
        <div className="Lt_title_text mb-3">
          <h2> Get a Tour of our Social Media </h2>
        </div>
        <InstaIframe/>
      </section>
    </>
  );
}

export default InstaLondon;
